module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0028.fddd37aa.jpg";